import React, { useCallback, useEffect, useState } from 'react';
import { Icon } from 'components';
import { ToastBody, ToastWrapper } from './styled';
import { toast, Zoom } from 'react-toastify';
import './styles.css';

export const renderInfoToast = (title: string, body: string): string | number => toast.info(
  <InfoToast title={title} body={body} />, {
    position: toast.POSITION.BOTTOM_LEFT,
    autoClose: false,
    hideProgressBar: true,
    transition: Zoom
  }
);

interface InfoModalProps {
  title: string;
  body: string;
}

const InfoToast = ({ title, body }: InfoModalProps): React.JSX.Element => {
  const [isAboveStickyCTA, setIsAboveStickyCTA] = useState(false);
  
  const checkStickyCTA = useCallback(() => {
    const sticky = document.getElementById('sticky-cta-container');
    setIsAboveStickyCTA(!!sticky && sticky.classList.contains('show'));
  }, []);

  useEffect(() => {
    checkStickyCTA();
    window.addEventListener('scroll', checkStickyCTA, { passive: true });

    return () => window.removeEventListener('scroll', checkStickyCTA);
  }, [checkStickyCTA]);

  return (
    <ToastWrapper id="toast-container" className={isAboveStickyCTA && 'above-sticky-cta'}>
      <Icon icon="info" color="#fff" size="small" testId="info-icon"/>

      <ToastBody>
        <h6>{title}</h6>
        <p>{body}</p>
      </ToastBody>

      <Icon icon="close" size="small" color="#fff" viewBox="0 2 22 22" testId="close-icon"/>
    </ToastWrapper>
  );
};

export default InfoToast;
